// --- Science Direct Technology ---

import React from 'react';
import PropTypes from 'prop-types';

function ElsRadioButton({
  id,
  name,
  value,
  label,
  onChange,
  checked,
}) {
  return (
    <label className="els-form-radio-button" htmlFor={id}>
      <input
        checked={checked}
        className="els-form-radio-input"
        title={label}
        id={id}
        name={name}
        type="radio"
        value={value}
        onChange={onChange}
      />
      <span className="els-form-radio-visual" />
      <span className="els-form-radio-label">{label}</span>
    </label>
  );
}

ElsRadioButton.propTypes = {
  id: PropTypes.string,
  name: PropTypes.string,
  value: PropTypes.string,
  label: PropTypes.string,
  onChange: PropTypes.func,
  checked: PropTypes.bool,
};

export default ElsRadioButton;
